import React from 'react';

import { CalendarContainer } from './CalendarContainer';

export const EventCalendar = () => {
  return <CalendarContainer />;
};
